import React from 'react';

const IFrameEmbed = ({
    src,
    title = "Embedded content",
    width = "100%",
    height = "100%",
    allowFullScreen = true,
    loading = "lazy",
    className = "",
    style = {},
    onLoad = null,
    onError = null
}) => {
    const handleLoad = (e) => {
        if (onLoad) onLoad(e);
    };

    const handleError = (e) => {
        if (onError) onError(e);
    };

    const iframeProps = {
        src,
        title,
        width,
        height,
        loading,
        onLoad: handleLoad,
        onError: handleError,
        className: `border-0 w-full h-full ${className}`,
        style: {
            border: 'none',
            ...style
        }
    };

    // Add allowFullScreen if enabled
    if (allowFullScreen) {
        iframeProps.allowFullScreen = true;
    }

    return (
        <iframe {...iframeProps} />
    );
};

export default IFrameEmbed